
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  mounted: function () {
    var self = this;
    var app = self.$app;
    self.getRemovedUnits();
  },
  methods: {
    //manage-equipment-form
    updateLocationEquipments: function () {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      var formData = self.$app.form.convertToData("#manage-equipment-form");
      console.log(formData);
      var data = {};
      Object.keys(formData).forEach(function (key, value) {
        var id = key.split("_")[1];
        data[id] = formData[key][0] ? 1 : 0;
      });
      console.log(data);
      self.$app.request({
        url: Url.to("location/manage-equipments"),
        method: "POST",
        data: {
          location_id: self.location.id,
          units: data
        },
        preloader: true,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);
          self.$router.back();
        }
      });
    },

    getRemovedUnits() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.$app.request({
        url: Url.to("location/get-removed-units"),
        method: "GET",
        data: {
          location_id: self.location.id
        },
        preloader: false,
        indicator: false,
        progress: false,
        success: function (data, status, xhr) {
          console.log(data);
          data['removed_units'].forEach(function (unit_id, index) {
            if (self.location.units[unit_id]) {
              self.location.units[unit_id]['removed'] = true;
            }
          });
          self.is_locked = data['is_locked'];
          self.$update();
        }
      });
    }

  },
  data: function () {
    var location = this.$route.context.location;
    return {
      location: location,
      is_locked: true
    };
  },
  id: 'aa7a4596b9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page no-toolbar" data-name="manage-equipments">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">';
      r += c(ctx_1.location.name, ctx_1);
      r += '</div>\n                <div class="right"></div>\n            </div>\n        </div>\n        <div class="page-content">\n            <div class="block-title">Manage Equipments</div>\n            <div class="list simple-list no-margin-bottom" id="manage-equipment-form">\n                <ul>\n                    ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.location.units, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <li class="';
          r += Template7Helpers.if.call(ctx_2, ctx_1.is_locked, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'disabled';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '">\n                        <div style="line-height: normal">\n                            <div>';
          r += c(ctx_2.name, ctx_2);
          r += '</div>\n                            <div>\n                                <small class="text-color-gray">';
          r += c(ctx_2.code, ctx_2);
          r += '</small>\n                            </div>\n                        </div>\n                        <label class="toggle toggle-init">\n                            <input ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.removed, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += 'checked';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            name="unit_';
          r += c(ctx_2.id, ctx_2);
          r += '" type="checkbox" value="1">\n                            <span class="toggle-icon"></span>\n                        </label>\n                    </li>\n                    ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                </ul>\n            </div>\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.is_locked, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="padding-horizontal">\n                <small class="text-color-gray">Turn off equipments you don\'t want to receive updates about</small>\n            </div>\n            <div @click="updateLocationEquipments" class="block margin-vertical-half">\n                <a class="button button-large button-fill" href="#">\n                    Save\n                </a>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    